import { useHistory } from "react-router-dom";
import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';

export interface IBookingStatus {
  totalVehicles: number
  daysInBooking: number
  endingThisMonth: number
}

const BookingStatus = ({ data }: { data: IBookingStatus }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation()
  const utilizationPercentage =
    data ? data.endingThisMonth > 0 ? (data.endingThisMonth / data.totalVehicles) * 100 : 0 : 0;
  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:bookingStatus")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #667eea, #764ba2)" }}>
            🗓️
          </Box>
        </Box>

        <Box>
          <Box style={{ margin: "5px 0" }}>
            <Typography variant="body2" style={{ color: "#64748b", fontSize: "14px", marginBottom: "4px" }}>
              Total Vehicles
            </Typography>
            <Typography
              variant="h3"
              style={{
                fontWeight: 700,
                color: "#1e293b",
                fontSize: "28px",
                lineHeight: "1.2",
                cursor: "pointer"
              }}
              onClick={() => history.push("/account/vehicles")}
            >
              {data.totalVehicles}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Box style={{ position: "relative", width: "80px", height: "80px", marginRight: "20px" }}>
              <svg width="80" height="80" viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="35" fill="none" stroke="#e2e8f0" strokeWidth="10" />
                <circle
                  cx="40"
                  cy="40"
                  r="35"
                  fill="none"
                  stroke="url(#bookingGradient)"
                  strokeWidth="10"
                  strokeDasharray={`${(utilizationPercentage / 100) * 220} 220`}
                  strokeDashoffset="0"
                  transform="rotate(-90 40 40)"
                />
                <defs>
                  <linearGradient id="bookingGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#667eea" />
                    <stop offset="100%" stopColor="#764ba2" />
                  </linearGradient>
                </defs>
              </svg>
            </Box>

            <Box style={{ flex: 1 }}>
              <Box
                style={{
                  marginBottom: "12px",
                  padding: "8px 12px",
                  backgroundColor: "#f8fafc",
                  borderRadius: "8px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <Typography variant="body2" style={{ color: "#64748b", fontSize: "12px", marginBottom: "2px" }}>
                  {t("root:daysInBooking")} : {data.daysInBooking}
                </Typography>
                <Typography variant="body2" style={{ color: "#64748b", fontSize: "10px", fontStyle: "italic" }}>
                  {t("root:accumulatedDays")}
                </Typography>
              </Box>
              <Box
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#eff6ff",
                  borderRadius: "8px",
                  border: "1px solid #bfdbfe",
                }}
              >
                <Typography variant="body2" style={{ color: "#64748b", fontSize: "12px", marginBottom: "2px" }}>
                  {t("root:endingThisMonth")}
                </Typography>
                <Typography variant="h6" style={{ color: "#2563eb", fontWeight: 600, fontSize: "16px" }}>
                  {data.endingThisMonth}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BookingStatus